module.exports = __webpack_public_path__ + "static/media/ACS XA Decision Log.aef467ff.csv";